<template>
  <div class="contaier py-[60px] md:py-0 md:mt-[6px]">
    <div class="form-box relative">
      <div class="title lg:text-[28px] text-2xl md:pb-[8px] pb-[4px] font-semibold">{{ $t('koc.form_title1') }}</div>
      <div class="title lg:text-[28px] text-2xl md:pb-[20px] pb-[15px] font-semibold">{{ $t('koc.form_title2') }}</div>
      <p class="note text-10px pb-[10px]" id="myElement">
        {{ $t('koc.mandatory') }}
      </p>
      <el-form :model="form" ref="formRef" :rules="formRules" label-width="80px" label-position="top">
        <el-row :gutter="20">
          <el-col>
            <el-form-item :label="$t('koc.plateNumber')" prop="plateNumber">
              <el-input v-model="form.plateNumber" :placeholder="$t('koc.enterPlateNumber')" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('koc.name')" prop="name">
              <el-input v-model="form.name" :placeholder="$t('koc.enterName')" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('koc.mobileNumber')" prop="phoneAreaCode" class="item-mb-0">
              <div class="phone-box">
                <div class="phone-sum">
                  <el-select
                    :popper-append-to-body="false"
                    style="width: 100%"
                    :value="form.phoneAreaCode"
                    @change="changePhoneAreaCode"
                  >
                    <el-option label="+852" value="852">
                      <span>{{ $t('koc.phoneHK') }}</span>
                    </el-option>
                    <el-option label="+86" value="86">
                      <span>{{ $t('koc.phoneCN') }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="phone-">
                  <el-form-item prop="phone">
                    <el-input
                      style="width: 100%"
                      v-model="form.phone"
                      :placeholder="form.phoneAreaCode == '852' ? $t('koc.enterPhoneHK') : $t('koc.enterPhoneCN')"
                      :maxlength="form.phoneAreaCode == '852' ? 8 : 11"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('koc.uploadPhoto')" prop="photo">
              <div class="photo-upload-wrap" ref="photoWrapRef" @click="triggerPhotoUpload">
                <el-upload
                  ref="uploadRef"
                  class="photo-upload"
                  :class="{ 'photo-upload-success': form.photo }"
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :limit="1"
                  :disabled="!!photoPreview || uploading"
                  accept="image/jpg,image/jpeg,image/png,image/gif,image/webp"
                  :before-upload="beforePhotoUpload"
                  :on-change="handlePhotoChange"
                >
                  <img v-if="photoPreview && !uploading" :src="photoPreview" class="photo-preview" alt="photo" />
                  <div v-else-if="!photoPreview && !uploading" class="photo-uploader">
                    <i class="el-icon-plus"></i>
                    <span class="photo-uploader-text">{{ $t('koc.uploadPhotoBtn') }}</span>
                  </div>
                  <div v-if="uploading" class="photo-loading-overlay">
                    <div class="photo-spinner"></div>
                    <span class="photo-loading-text">上傳中...</span>
                  </div>
                  <i v-if="photoPreview && !uploading" class="el-icon-close photo-remove" @click.stop="removePhoto"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn-box">
        <div
          class="btn bg-[var(--btn-bg)] text-[var(--btn-color)] font-bold"
          :style="{ '--btn-bg': btn.btnBg, '--btn-color': btn.btnColor }"
          @click="submitForm"
        >
          {{ $t('koc.submit') }}
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" top="40vh" width="320px" center>
      <div class="mt-[-26px]">
        <p class="text-[18px] text-[#111] text-center">{{ errorMsg }}</p>
      </div>
    </el-dialog>

    <el-dialog
      class="cLoading"
      top="35vh"
      width="190px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible2"
    >
      <div class="dialog-box dialog-box2">
        <i class="el-icon-loading icon-check"></i>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogSuccess" top="35vh" width="320px" center :close-on-click-modal="false">
      <div class="success-dialog">
        <div class="success-dialog__icon">
          <i class="el-icon-check"></i>
        </div>
        <h3 class="success-dialog__title">提交成功</h3>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from '@/assets/js/event-bus'
import { cloneDeep } from 'lodash'
import { imgUploadsApi, icaurKocAddApi } from '@/Api/requestApi'

export default {
  name: 'FormPage',
  components: {},
  props: {
    brand: { type: Object, default: () => ({}) },
    carList: { type: Array, default: () => [] },
    btn: { type: Object, default: () => ({ btnBg: '#000', btnColor: '#fff' }) },
  },
  data() {
    let validatePlateNumber = (rule, value, callback) => {
      if (!value) return callback(new Error(this.$t('koc.enterPlateNumber')))
      callback()
    }
    let validateName = (rule, value, callback) => {
      if (!value) return callback(new Error(this.$t('koc.enterName')))
      callback()
    }
    let phoneAreaCode = (rule, value, callback) => {
      if (!value) return callback(new Error(this.$t('koc.enterPhoneHK')))
      callback()
    }
    let phonecode = (rule, value, callback) => {
      const isHK = this.form.phoneAreaCode === '852'
      if (!value) {
        return callback(new Error(isHK ? this.$t('koc.enterPhoneHK') : this.$t('koc.enterPhoneCN')))
      }
      const regExp = isHK ? /^(4|5|6|7|8|9)\d{7}$/ : /^1[3-9]\d{9}$/
      if (!regExp.test(value)) {
        return callback(new Error(isHK ? this.$t('koc.rightPhoneHK') : this.$t('koc.rightPhoneCN')))
      } else {
        callback()
      }
    }
    let validatePhoto = (rule, value, callback) => {
      if (!value) return callback(new Error(this.$t('koc.uploadPhotoTip')))
      callback()
    }

    return {
      dialogVisible: false,
      dialogVisible2: false,
      dialogSuccess: false,
      errorMsg: '',
      photoPreview: '',
      uploading: false,
      form: {
        plateNumber: '',
        name: '',
        phoneAreaCode: '852',
        phone: '',
        photo: '',
      },
      formRules: {
        plateNumber: [{ required: true, validator: validatePlateNumber, trigger: 'blur' }],
        name: [{ required: true, validator: validateName, trigger: 'blur' }],
        phoneAreaCode: [{ required: true, validator: phoneAreaCode, trigger: 'change' }],
        phone: [{ required: true, validator: phonecode, trigger: 'change' }],
        photo: [{ required: true, validator: validatePhoto, trigger: 'change' }],
      },
    }
  },
  created() {
    EventBus.$on('message', this.receiveMessage)
  },
  beforeDestroy() {
    EventBus.$off('message', this.receiveMessage)
  },
  mounted() {},
  methods: {
    receiveMessage(msg) {
      this.changeLanguage(msg)
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let formDate_ = cloneDeep(this.form)
          formDate_.phone = formDate_.phoneAreaCode + ' ' + formDate_.phone
          this.dialogVisible2 = true
          const {
            data: { code, message },
          } = await icaurKocAddApi(formDate_)

          if (code === 200) {
            this.form = {
              plateNumber: '',
              name: '',
              phoneAreaCode: '852',
              phone: '',
              photo: '',
            }
            this.photoPreview = ''
            this.$refs.formRef.resetFields()
            setTimeout(() => {
              this.dialogSuccess = true
              this.dialogVisible2 = false
            }, 1000)
          } else if (code === 400) {
            this.errorMsg = message
            this.$message({ message: this.errorMsg || this.$t('koc.submitFail'), type: 'error' })
            setTimeout(() => {
              this.dialogVisible2 = false
              this.dialogVisible = true
            }, 500)
          }
        } else {
          document.getElementById('myElement')?.scrollIntoView()
          return false
        }
      })
    },
    resetForm() {
      this.$refs.formRef.resetFields()
    },
    changeLanguage(e) {
      this.$refs.formRef.resetFields()
      this.form.language = e === 'en' ? 'English' : '繁體中文'
    },
    changePhoneAreaCode(v) {
      this.form.phoneAreaCode = v
      this.$nextTick(() => {
        this.$refs.formRef.validateField('phone')
      })
    },
    triggerPhotoUpload(e) {
      if (this.photoPreview) return
      const wrapEl = this.$refs.photoWrapRef
      if (!wrapEl) return
      const uploadEl = wrapEl.querySelector('.el-upload')
      if (e && e.target && uploadEl && uploadEl.contains(e.target)) return
      const input = wrapEl.querySelector('input[type="file"]')
      if (input) input.click()
    },
    beforePhotoUpload(file) {
      if (!file.type.startsWith('image/')) {
        this.$message({ message: this.$t('koc.photoOnly'), type: 'warning' })
        return false
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message({ message: this.$t('koc.photoOnly'), type: 'warning' })
        return false
      }
      return true
    },
    async handlePhotoChange(file) {
      const raw = file && file.raw
      if (!raw) return
      const reader = new FileReader()
      reader.onload = (e) => {
        this.photoPreview = e.target.result
        this.form.photo = e.target.result
      }
      reader.readAsDataURL(raw)

      this.uploading = true
      try {
        const formData = new FormData()
        formData.append('image', raw)
        formData.append('_brandUrl', 'icaur')
        const res = await imgUploadsApi(formData)
        const payload = (res && res.data) || {}
        const { success, results } = payload
        if (success == true) {
          this.form.photo = results[0].image
          this.$nextTick(() => {
            this.$refs.formRef.validateField('photo')
          })
        } else {
          this.$message({ message: '圖片不能超過 2MB', type: 'error' })
          this.resetPhoto()
        }
      } catch (err) {
        this.$message({ message: this.$t('koc.submitFail'), type: 'error' })
        this.resetPhoto()
      } finally {
        this.uploading = false
      }
    },
    resetPhoto() {
      this.form.photo = ''
      this.photoPreview = ''
      this.uploading = false
      const uploadRef = this.$refs.uploadRef
      if (uploadRef && typeof uploadRef.clearFiles === 'function') {
        uploadRef.clearFiles()
      } else {
        const wrapEl = this.$refs.photoWrapRef
        if (wrapEl) {
          const input = wrapEl.querySelector('input[type="file"]')
          if (input) input.value = ''
        }
      }
      this.$refs.formRef && this.$refs.formRef.validateField('photo')
    },
    removePhoto() {
      this.resetPhoto()
    },
  },
}
</script>

<style lang="scss">
.hide-adjacent-months .next-month,
.hide-adjacent-months .prev-month {
  visibility: hidden;
}
.row-expand-cover td .el-table__expand-icon {
  visibility: hidden;
}
.custom-class-dialog1 {
  background-color: #f56c6c;
  .el-dialog__body {
    padding: 22px 15px 48px 15px !important;
  }
}
input[aria-hidden='true'] {
  display: none !important;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 26px !important;
}

.item-mb-0 {
  margin-bottom: 0 !important;
}

::v-deep .el-dialog__headerbtn {
  font-size: 25px;
  top: 7px;
  right: 14px;
}
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #f48e30;
}
::v-deep .el-dialog__headerbtn:focus .el-dialog__close {
  color: #f48e30;
}

.success-dialog {
  text-align: center;
  padding: 10px 0 20px;
  .success-dialog__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: #67c23a;
    margin-bottom: 18px;
    i {
      font-size: 36px;
      color: #fff;
      font-weight: 700;
    }
  }
  .success-dialog__title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}

.contaier {
  background-color: #fff;

  ::v-deep .cLoading .el-dialog {
    border-radius: 10px !important;
    background: none !important;
    background-color: rgba(000, 000, 000, 0.6) !important;
  }

  [aria-hidden='true'] {
    display: none !important;
  }

  .form-box {
    width: 92%;
    margin: 0 auto;
    max-width: 1200px;

    .phone-box {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      .phone-sum {
        width: 100px;
        margin-right: 20px;
        font-size: 1.1rem !important;
        font-weight: 400;
      }
      .phone- {
        flex: 1;
      }
    }

    .photo-upload-wrap {
      display: flex;
      width: 200px;
      min-height: 120px;
    }

    .photo-upload {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      min-height: 120px;
      border: 1px dashed #999;
      border-radius: 4px;
      cursor: pointer;
      position: relative;
    }

    .photo-upload-success {
      border-color: #67c23a;
    }
    .photo-upload-success:hover {
      border-color: #67c23a !important;
    }
    .photo-upload:hover {
      border-color: #f48e30;
    }

    .photo-uploader {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      .el-icon-plus {
        font-size: 28px;
        margin-bottom: 8px;
      }
    }

    .photo-uploader-text {
      font-size: 0.95rem;
      line-height: 1rem;
    }

    .photo-preview {
      width: 100%;
      max-height: 120px;
      object-fit: contain;
      display: block;
    }

    .photo-remove {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.8);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      line-height: 1;
      z-index: 2;
    }
    .photo-remove:hover {
      background: rgba(0, 0, 0, 0.8);
    }

    .photo-loading-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.88);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      z-index: 3;
    }

    .photo-spinner {
      width: 28px;
      height: 28px;
      border: 3px solid #e8e8e8;
      border-top-color: #f48e30;
      border-radius: 50%;
      animation: photoSpin 0.7s linear infinite;
    }

    .photo-loading-text {
      margin-top: 8px;
      font-size: 12px;
      color: #999;
    }

    @keyframes photoSpin {
      to { transform: rotate(360deg); }
    }

    .note {
      color: #999;
    }
    .note:before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }

    ::v-deep .el-input {
      font-size: 1.05rem !important;
    }
    ::v-deep .el-form-item__label {
      font-size: 1.15rem !important;
      line-height: 1.6rem !important;
      font-weight: 400;
    }
    ::v-deep .el-input__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: #666 1px solid !important;
    }
    ::v-deep .is-error .el-input__inner {
      border-bottom: #f56c6c 2px solid !important;
    }
  }

  .btn-box {
    padding-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    .btn {
      width: 200px;
      line-height: 40px;
      border-radius: 20px;
      cursor: pointer;
    }
  }
}

.dialog-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .icon-check {
    font-size: 60px;
    font-weight: 600;
    color: #fff;
  }
  .title {
    padding-top: 10px;
    font-size: 16px;
    color: #fff;
  }
}
.dialog-box2 {
  padding-top: 5px;
  padding-bottom: 30px;
}
</style>
